import script from "./UserManageView.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserManageView.vue?vue&type=script&setup=true&lang=ts"

import "./UserManageView.vue?vue&type=style&index=0&id=88c01420&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-88c01420"]])

export default __exports__